/**
 * Download de arquivo que vem da API (xlsx do Balanceamento, csv dos apontamentos).
 *
 * O `apiService` injeta o JWT, então um `<a href>` direto para a API não serve: o arquivo
 * vem como `Blob` pelo axios e vira download aqui.
 */

/** Lê o corpo de um Blob sem depender de `Blob.text()` — o jsdom não o implementa. */
export async function lerBlob(blob: Blob): Promise<string> {
  if (typeof blob.text === 'function') return blob.text();
  return new Promise((resolve) => {
    const leitor = new FileReader();
    leitor.onload = () => resolve(String(leitor.result ?? ''));
    leitor.onerror = () => resolve('');
    leitor.readAsText(blob);
  });
}

/** `createObjectURL` → `<a download>` → `revokeObjectURL`. */
export function baixarArquivo(blob: Blob, nome: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** O nome vem do `Content-Disposition`; sem ele, o `fallback`. */
export function nomeDoContentDisposition(headers: unknown, fallback: string): string {
  const bruto = (headers as Record<string, string> | undefined)?.['content-disposition'] ?? '';
  return /filename="([^"]+)"/.exec(bruto)?.[1] ?? fallback;
}
